import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import React from "react";
import { ConfigProvider } from "antd";
import Dashboard from "./../pages/Dashboard/dashboard";
import Admin from "./../pages/Admin/list/admin";
import NoAccess from "./../no-access";
import DataTransfer from "./../pages/DataTransfer/data-transfer";
import Header from "./../components/Header/header";
import PackageHistory from "./../pages/PackageHistory/package-history";
import UserList from "./../pages/Admin/users/user-list";
import TransferIds from "./../pages/Admin/TransferIds/TransferIdTable/transfer-ids";
import TransferIdCreateEdit from "./../pages/Admin/TransferIds/TransferIdCreateEdit/transfer-id-create-edit";
import { AuthCallback } from "../auth-callback";
import NotFound from "../pages/NotFound/not-found";

type RouterProps = {
  isAuthenticated: boolean;
  userRole: string | null;
};

const Router: React.FC<RouterProps> = ({ isAuthenticated, userRole }) => {
  return (
    <BrowserRouter>
      <ConfigProvider theme={{}}>
        <AppContent isAuthenticated={isAuthenticated} userRole={userRole} />
      </ConfigProvider>
    </BrowserRouter>
  );
};

const HEADER_PATHS = ["/", "/dashboard", "/data-transfer", "/admin", "/package-history"];

const AppContent: React.FC<RouterProps> = ({ isAuthenticated, userRole }) => {
  const { pathname } = useLocation();
  const showHeader = HEADER_PATHS.some((p) => pathname === p || pathname.startsWith(p + "/"));

  return (
    <div>
      {showHeader && <Header isAuthenticated={isAuthenticated} role={userRole} />}
      <Routes>
        <Route path="/" element={isAuthenticated && <Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/data-transfer" element={<DataTransfer />} />
        <Route path="/admin" element={<Admin />}>
          <Route index element={<Navigate to="users" replace />} />
          <Route path="users" element={<UserList />} />
          <Route path="transfer-ids" element={<TransferIds />} />
        </Route>
        <Route path="/admin/transfer-ids/create" element={<TransferIdCreateEdit />} />
        <Route path="/admin/transfer-ids/edit/:id" element={<TransferIdCreateEdit />} />
        <Route path="/package-history" element={<PackageHistory />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/no-access" element={<NoAccess />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
};

export default Router;
